/**
 * @group Constants
@summary EHR integration linking status values

<blockquote>
Defines the status values for EHR integration linking lifecycle.
Tracks the state of OpenEMR patient creation and linking process.
</blockquote>

@example
```typescript
const status = EHR_INTEGRATION_STATUSES.PENDING;
// 'pending'

// Status lifecycle:
// PENDING → LINKED (success)
// PENDING → FAILED (failure after retries)
```
 * @internal
 */
export const EHR_INTEGRATION_STATUSES = {
  /** OpenEMR patient creation in progress or queued for retry */
  PENDING: 'pending',
  /** Successfully linked with OpenEMR patient ID */
  LINKED: 'linked',
  /** OpenEMR linking failed after retries (manual intervention needed) */
  FAILED: 'failed',
} as const;
